export enum transferStatus {
  /**
   * 待转换
   */
  'waiting' = 'waiting',
  /**
   * 转换中
   */
  'transfering' = 'transfering',
  /**
   * 转换成功
   */
  'transfered' = 'transfered',
  /**
   * 转换失败
   */
  'fail' = 'fail',
}
